var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLeftArrow(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 8,
    height: 14,
    viewBox: "0 0 8 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M2.59986 7.71006C2.50613 7.6171 2.43174 7.5065 2.38097 7.38464C2.3302 7.26278 2.30406 7.13207 2.30406 7.00006C2.30406 6.86805 2.3302 6.73734 2.38097 6.61548C2.43174 6.49362 2.50613 6.38302 2.59986 6.29006L7.18986 1.71006C7.28359 1.6171 7.35798 1.5065 7.40875 1.38464C7.45952 1.26278 7.48566 1.13207 7.48566 1.00006C7.48566 0.868048 7.45952 0.737343 7.40875 0.615483C7.35798 0.493624 7.28359 0.383023 7.18986 0.29006C7.0025 0.103809 6.74905 -0.000732422 6.48486 -0.000732422C6.22067 -0.000732422 5.96722 0.103809 5.77986 0.29006L1.18986 4.88006C0.628058 5.44256 0.3125 6.20506 0.3125 7.00006C0.3125 7.79506 0.628058 8.55756 1.18986 9.12006L5.77986 13.7101C5.96612 13.8948 6.21752 13.999 6.47986 14.0001C6.61147 14.0008 6.74193 13.9756 6.86377 13.9258C6.9856 13.8761 7.09642 13.8027 7.18986 13.7101C7.28359 13.6171 7.35798 13.5065 7.40875 13.3846C7.45952 13.2628 7.48566 13.1321 7.48566 13.0001C7.48566 12.868 7.45952 12.7373 7.40875 12.6155C7.35798 12.4936 7.28359 12.383 7.18986 12.2901L2.59986 7.71006Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLeftArrow);
export default __webpack_public_path__ + "static/media/left-arrow.43bcc5f047741e2354300887e50cae3a.svg";
export { ForwardRef as ReactComponent };